var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    viewBox: "0 0 96 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7885 74.973C32.9535 74.973 33.4355 73.9026 32.4577 71.2032L24.1218 43.7698L88.2885 5.70215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7883 74.9729C37.9758 74.9729 38.942 73.9725 40.1633 72.7854L51.83 61.4411L37.2773 52.6655"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.276 52.6677L72.5385 78.7201C76.5627 80.9404 79.4663 79.7905 80.4689 74.9846L94.8225 7.34491C96.2918 1.45324 92.5767 -1.21988 88.7267 0.52793L4.44233 33.0276C-1.3108 35.3354 -1.27652 38.5452 3.39379 39.9751L25.0231 46.7265L75.0971 15.1353C77.4611 13.7018 79.6311 14.4718 77.8504 16.0526"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.317a4909.svg";
export { ForwardRef as ReactComponent };